import React from "react";
import { titleCase } from "../../../utils/common";
import { withStyles } from "@material-ui/core/styles";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import moment from "moment-timezone";
import CloseIcon from "@material-ui/icons/Close";

import {
  Avatar,
  Grid,
  IconButton,
  makeStyles,
  Tooltip,
} from "@material-ui/core";
import { psTranslate } from "../../shared/translations";
import SpText from "../../../components/atoms/SpText";

const useStyles = makeStyles((themeStyle) => ({
  largeAvatar: {
    margin: "8px",
    width: themeStyle.spacing(4),
    height: themeStyle.spacing(4),
  },
  smallAvatar: {
    margin: "8px",
    width: themeStyle.spacing(3),
    height: themeStyle.spacing(3),
  },
}));

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 15,
  },
}))(Tooltip);

export const SpCalendarItemOrganization = ({
  activitiesAvailable,
  handleDragStart,
}) => {
  const classes = useStyles();
  return (
    <Grid
      xs={12}
      style={{
        position: "sticky",
        top: 0,
        height: "100%",
        marginTop: "58px",
      }}
      key={"activity_type_list"}
    >
      {activitiesAvailable.map((p) => (
        <div
          id={`activity-${p.key}`}
          className="rbc-event dd-calendar-items"
          draggable="true"
          onDrag={(e) => {
            e.preventDefault();
            handleDragStart(p);
          }}
          key={p.key}
        >
          <div
            className="rbc-event-label"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Avatar
                imgProps={{
                  style: {
                    maxHeight: "100%",
                    maxWidth: "100%",
                    objectFit: "cover",
                  },
                }}
                className={classes.largeAvatar}
                src={p?.profileImage}
              />

              <div>
                <SpText variant="textWhite">{`${p.name} ${p.surname}`}</SpText>
              </div>
            </div>
          </div>
        </div>
      ))}
    </Grid>
  );
};
export const ColoredEventCellHelperMonth = ({
  event,
  type = "month",
  selectedProfessional,
}) => {
  return (
    <ColoredEventCellHelper
      event={event}
      type={type}
      selectedProfessional={selectedProfessional}
    />
  );
};
export const ColoredEventCellHelperDay = ({ event, type = "day" }) => {
  return <ColoredEventCellHelper event={event} type={type} />;
};
export const ColoredEventCellHelperWeek = ({ event, type = "week" }) => {
  return <ColoredEventCellHelper event={event} type={type} />;
};

export const ColoredEventCellHelper = ({
  event,
  type = "month",
  selectedProfessional,
  ...props
}) => {
  const classes = useStyles();
  return (
    <div id={`event-${event.id}`} style={{ padding: "0" }}>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        style={{ padding: "0" }}
      >
        <Grid item xs={3} justifyContent="center" alignItems="center">
          <Avatar
            imgProps={{
              style: {
                maxHeight: "100%",
                maxWidth: "100%",
                objectFit: "cover",
              },
            }}
            className={classes.smallAvatar}
            src={event?.media}
          />
        </Grid>

        <Grid
          item
          xs={7}
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <SpText variant="textWhiteArchivedBold" color={"white"}>
            {`${titleCase(event.name.charAt(0))}. ${titleCase(event.surname)}`}
          </SpText>

          {type == "month" && (
            <SpText variant="textWhiteArchivedBold" color={"white"}>
              {moment(event.start).format("HH:mm")}
              {" - "}
              {moment(event.end).format("HH:mm")}
            </SpText>
          )}
        </Grid>

        {!selectedProfessional && (
          <Grid item xs={2} justifyContent="center" alignItems="center">
            <IconButton
              size="small"
              onClick={() => {}}
              style={{ color: "white" }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Grid>
        )}
      </Grid>
    </div>
  );
};
